import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "../";
import MenuImportModal from "./MenuImportModal";

/**
 * Generic menu importer card — same layout for all platforms (DoorDash, Uber Eats, etc.).
 * Renders platform logo, title, description, and "Import Menu" button.
 * Accepts config via props; modal config is platform-specific.
 */
const MenuImporterCard = ({
  titleKey,
  descriptionKey,
  importButtonKey,
  logoColor = "#6B7280",
  modalConfig,
}) => {
  const { t } = useTranslation("menuImporters");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleImportClick = (e) => {
    e.stopPropagation();
    setIsModalOpen(true);
  };

  return (
    <>
      <div className="flex h-full flex-col rounded-lg border border-gray-800 bg-gray-900 p-6 transition-colors hover:bg-gray-800/50">
        <div className="mb-4">
          <div className="mb-3 flex items-start justify-between">
            <div className="flex items-center space-x-3">
              <div
                className="flex h-12 w-12 flex-shrink-0 items-center justify-center overflow-hidden rounded-lg border border-gray-700"
                style={{ backgroundColor: logoColor }}
              >
                <Icon name="Store" className="h-6 w-6 text-white" />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="mb-1 text-lg font-semibold text-white">
                  {t(titleKey)}
                </h3>
                <p className="text-sm text-gray-400">{t(descriptionKey)}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-auto space-y-2 border-t border-gray-800 pt-4">
          <button
            onClick={handleImportClick}
            className="flex w-full items-center justify-center rounded-lg bg-gradient-to-r from-blue-600 to-purple-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:from-blue-700 hover:to-purple-700"
          >
            {t(importButtonKey)}
          </button>
        </div>
      </div>

      {modalConfig && (
        <MenuImportModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          config={modalConfig}
        />
      )}
    </>
  );
};

export default MenuImporterCard;
